module.exports = __webpack_public_path__ + "img/bycicle.76bf0543.svg";